import React from "react";
import { Map, ZoomControl, MapProps } from "react-leaflet";
import styled from "@emotion/styled";

const MapContainer = styled.div<{ isDisabled: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  ${(props) =>
    props.isDisabled &&
    `
    pointer-events: none;
    opacity: 0.7;
  `}
`;

const DisabledOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 10000;
`;

interface LeafletMapProps extends MapProps {
  setMapRef: (ref: any) => void;
  children: React.ReactNode;
  isDisabled?: boolean;
}

function LeafletMap({
  children,
  setMapRef,
  isDisabled = false,
  ...otherProps
}: LeafletMapProps): JSX.Element {
  return (
    <MapContainer isDisabled={isDisabled}>
      <Map
        {...otherProps}
        zoomControl={false}
        ref={(ref) => {
          // @ts-ignore
          window.currentMapReference = ref;
          setMapRef(ref);
        }}
        dragging={!isDisabled}
        touchZoom={!isDisabled}
        doubleClickZoom={!isDisabled}
        scrollWheelZoom={!isDisabled}
        boxZoom={!isDisabled}
        keyboard={!isDisabled}
      >
        {isDisabled ? null : <ZoomControl position="topright" hidden={true} />}
        {children}
      </Map>
      {isDisabled && <DisabledOverlay />}
    </MapContainer>
  );
}

LeafletMap.defaultProps = {
  setMapRef: () => {},
  isDisabled: false,
};

export default LeafletMap;
